import {Display, Text} from '@/components/ui/Typography'
import React, {ReactNode} from 'react'

type TailwindBgColor = `bg-${string}`
type TailwindTextColor = `text-${string}`

interface TopSectionWithIconProps {
  bgColor: TailwindBgColor
  icon: ReactNode
  titleColor: TailwindTextColor
  text?: string
  title: string
  subTitleColor?: TailwindTextColor
  subTitle: string
}

export const TopSectionWithIcon: React.FC<TopSectionWithIconProps> = ({bgColor, title, subTitle, icon, text, titleColor, subTitleColor}) => {
  return (
    <section className="relative pt-16 pb-10">
      <div className={`absolute inset-0 h-1/2 ${bgColor}`} />
      <div className="absolute inset-0 top-1/2 h-1/2 bg-white" />

      <div className="relative z-10 container mx-auto text-center">
        <Display className={`text-5xl font-bold mb-2 ${titleColor}`}>{title}</Display>
        <Display className={`font-bold text-2xl ${subTitleColor ?? titleColor}`}>{subTitle}</Display>

        <div className="relative z-20 flex justify-center -mt-4 mb-4">{icon}</div>

        {text && <Text className="text-gray-700 text-xl font-bold max-w-2xl mx-auto">{text}</Text>}
      </div>
    </section>
  )
}
